<template>
  <MTableCell
    class="m-table-cell__default"
    @click="$emit('click-trigger')"
  >
    <div 
    class="m-table-cell__ellipsis-wrapper"
    :title="value"
    >
      {{ value }}
    </div>
  </MTableCell>
</template>

<script>
  import {mdash} from 'utils/typing/symbols';
  import MTableCell from 'components/Data/Tables/MTable/cells/MTableCell';

  export default {
    name: 'MTableCellDefault',
    components: {MTableCell},
    props: {
      index: {
        type: [Number, String],
        default: ''
      },
      itemKey: {
        type: String,
        default: ''
      },
      tableRow: {
        type: Object,
        default: Object
      }
    },
    computed: {
      value () {
        return this.tableRow[this.itemKey] || mdash;
      }
    }
  };
</script>
